import { useEffect, useState } from 'react';

import { MapRef } from 'react-map-gl/mapbox';

import { SquareIconButton } from '@/shared/components/iconButton';
import { Maximize2, Minimize2 } from '@/shared/components/icons';

interface MapFullscreenProps {
  mapRef: MapRef | null;
  containerId?: string;
}

const MapFullscreenControl = ({ mapRef, containerId }: MapFullscreenProps) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleChange = () => {
      let container: HTMLElement | null = null;
      if (containerId) {
        container = document.getElementById(containerId);
      } else if (mapRef) {
        container = mapRef.getMap().getContainer();
      }

      setIsFullscreen(document.fullscreenElement === container);
    };

    document.addEventListener('fullscreenchange', handleChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleChange);
    };
  }, [containerId, mapRef]);

  const toggleFullscreen = () => {
    let container: HTMLElement | null = null;
    if (containerId) {
      container = document.getElementById(containerId);
    } else if (mapRef) {
      container = mapRef.getMap().getContainer();
    }

    if (!container) {
      return;
    }

    if (document.fullscreenElement === container) {
      void document.exitFullscreen();
    } else {
      void container.requestFullscreen();
    }
  };

  return (
    <SquareIconButton
      onClick={toggleFullscreen}
      aria-label='toggle fullscreen'
      size='small'
      color='inherit'
    >
      {isFullscreen ? (
        <Minimize2 fontSize='small' />
      ) : (
        <Maximize2 fontSize='small' />
      )}
    </SquareIconButton>
  );
};

export default MapFullscreenControl;
